'use strict';

// A button to open up the help information

angular.module('msCore').directive('msIe8Warn', [function () {
  return {
    restrict: 'A',
    link: function link(scope, element) {
      element.hide();
      element.find('.closeBanner').on('click', function (e) {
        e.preventDefault();
        element.slideToggle('fast');
      });
    },
    templateUrl: 'core/templates/ie8warn.html',
    replace: true
  };
}]);